import { combineEpics } from "redux-observable";
import handleAllErrorsEffect from "./handle-all-errors-effect";
import { updateEffect } from "./update-effect";

export const notificationsEffects = combineEpics(
  handleAllErrorsEffect,
  updateEffect
);
